import React from 'react';
import { Link } from 'react-router-dom';

const ArticleCard = ({ article, index = 0 }: { article: any; index?: number }) => {
   const title: string = article?.title || 'Untitled';
   const external = !!article?.domain;
   const inner = (
      <>
         {article?.cover && (
            <div className="relative aspect-[16/9] overflow-hidden">
               <img
                  src={article.cover}
                  alt=""
                  loading="lazy"
                  className="h-full w-full object-cover grayscale brightness-75 transition-[transform,filter] duration-700 group-hover:scale-105 group-hover:grayscale-0"
               />
               <div className="absolute inset-0 bg-gradient-to-t from-ink-900 to-transparent" />
            </div>
         )}
         <div className="flex flex-1 flex-col p-5">
            <span className="mb-3 font-mono text-[11px] tracking-[0.2em] text-signal">
               SRC/{String(index + 1).padStart(2, '0')}
            </span>
            <h3 className="font-sans text-lg font-medium leading-snug text-bone">
               {title.length > 110 ? `${title.substring(0, 110)}…` : title}
            </h3>
            <div className="mt-auto flex items-center justify-between pt-6">
               <span className="eyebrow truncate">{external ? article.domain : 'Red Sentinel'}</span>
               <span className="flex h-8 w-8 items-center justify-center rounded-full border border-white/15 transition-all duration-300 group-hover:rotate-[-45deg] group-hover:border-signal group-hover:bg-signal group-hover:text-ink-950">
                  →
               </span>
            </div>
         </div>
      </>
   );

   const cls =
      'group flex h-full flex-col overflow-hidden rounded-sm border border-white/[0.07] bg-ink-900/60 backdrop-blur-md transition-colors duration-500 hover:border-signal/40';

   return external ? (
      <a href={article.url} target="_blank" rel="noopener noreferrer" className={cls}>
         {inner}
      </a>
   ) : (
      <Link to={`/article/${article?.id}`} className={cls}>
         {inner}
      </Link>
   );
};

export default ArticleCard;
